import { Fragment } from "react";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import ProgressLoader from "../../components/ProgressLoader/ProgressLoader";
import { Outlet } from "react-router-dom";

const DefaultLayout = () => {
    return (
        <div className="flex flex-col h-[100dvh] overflow-hidden">
            <Header />
            <main className="flex-1 overflow-y-auto pb-[80px]">
                <Outlet/>
            </main>
            <ProgressLoader />
            <Footer/>
        </div>
    );
};

export default DefaultLayout;
